import { NgModule } from "@angular/core";
import { ClientListComponent } from "./client-list/client-list.component";
import { ClientModalComponent } from "./client-modal/client-modal.component";
import { AuthGuard } from "../../util/guard/auth.guard";
import { RouterModule } from "@angular/router";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgxDatatableModule } from "@siemens/ngx-datatable";
import { NgSelectModule } from "@ng-select/ng-select";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { ComponentsModule } from "../../util/components/components.module";
import { NgbAlertModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { OfficesResolver } from "../../util/resolver/offices.resolver";
import { HousingsResolver } from "../../util/resolver/housings.resolver";
import { ReportsListComponent } from "./reports-list/reports-list.component";
import { TimeframeModalComponent } from "./timeframe-modal/timeframe-modal.component";

const routes = [
  {
    path: "clients",
    component: ClientListComponent,
    canActivate: [AuthGuard],
    resolve: {
      offices: OfficesResolver,
      housings: HousingsResolver,
    },
  },
];

@NgModule({
  declarations: [ClientListComponent, ClientModalComponent, ReportsListComponent, TimeframeModalComponent],
  imports: [
    RouterModule.forChild(routes),
    ContentHeaderModule,
    CoreCommonModule,
    NgxDatatableModule,
    NgSelectModule,
    SweetAlert2Module,
    ComponentsModule,
    NgbNavModule,
    NgbAlertModule,
  ],
})
export class ClientsModule {}
